export default __webpack_public_path__ + "25cf5fa496965254d3396bd9e5c09cad.svg";